import { createFileRoute } from "@tanstack/react-router";

import { MongodbViewerPanel } from "@/features/mongodb/mongodb-viewer-panel";

export const Route = createFileRoute("/_authenticated/nvwa/mongodb")({
  component: NvwaMongodbRoute,
});

function NvwaMongodbRoute() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <MongodbViewerPanel
        target="nvwa"
        title="NVWA DocumentDB"
        description="Query NVWA DocumentDB collections (read-only in prod)."
        allowDatabaseSelect
      />
    </div>
  );
}
